import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moRival from '../../store/rival';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

const RecruitChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const recruitRef = useRef<any>(null);
  let chart: any = null;
  const { activeComapny, rivalList } = moRival;

  const getResult = useMemo(() => {
    const Xdata: any = [];
    const data: any = [];
    rivalList?.forEach((ele: any) => {
      if (ele.company_name === activeComapny) {
        ele?.recruit_trend?.forEach((res: any) => {
          Xdata.push(res.batch);
          data.push(res.amount);
        });
      }
    });
    return { Xdata, data };
  }, [rivalList, activeComapny]);

  const render = () => {
    if (chart) chart.dispose();
    chart = init(recruitRef.current);
    const option = {
      grid: {
        top: 10,
        right: 20,
        bottom: 20,
        left: 20,
      },
      xAxis: {
        type: 'category',
        data: getResult.Xdata,
        axisTick: { show: false },
        axisLine: {
          show: true,
          lineStyle: { color: Color.ec },
        },
        axisLabel: {
          show: true,
          fontSize: 12,
          color: Color.blackColor(0.5),
          fontFamily: 'Roboto',
          interval: getResult.Xdata.length - 2,
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false,
        },
        axisTick: { show: false },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          name: '近一年变化趋势',
          type: 'line',
          data: getResult.data,
          label: {
            show: false,
          },
          smooth: true,
          symbol: 'emptyCircle',
          symbolSize: 6,
          showSymbol: true,
          areaStyle: {
            color: Color.primaryColor(0.1),
          },
          // markPoint: {
          //   data: [
          //     {
          //       type: "max",
          //       name: "Max",
          //       symbol: 0,
          //       symbolSize: 6,
          //       label: { show: false },
          //       itemStyle: {
          //         color: Color.red,
          //       },
          //     },
          //     {
          //       type: "min",
          //       name: "Min",
          //       symbol: 0,
          //       symbolSize: 6,
          //       label: { show: false },
          //       itemStyle: {
          //         color: Color.success,
          //       },
          //     },
          //   ],
          // },
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    if (!isEmpty(rivalList)){
      render();
    }
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [activeComapny, rivalList]);

  return (
    <section>
      {!isEmpty(rivalList) ? (
        <section className="recruit-chart" ref={recruitRef} />
      ) : (
        <Empty height="auto" />
      )}
    </section>
  );
};

export default observer(RecruitChart);
